

export function validateAtrTrail(pctOfAtr, ATR) {
  if (pctOfAtr <= 0) return [false, 'Percent of ATR must be larger than 0.'];
  if (ATR.candlesBack <= 0)
    return [false, 'Candles back must be larger than 0.'];
  
  if (ATR.candleDuration <= 0)
    return [false, 'Candle duration must be larger than 0.'];
  
  return [true, ''];
}
